import { createReducer } from '@src/redux/helpers/createReducer';

import {
  GET_CLAIM,
  VERIFY_PAYMENT_INFO,
  SET_MAIN_RADIO_GROUP,
  SET_IS_PROCEDURE_CODE,
  RESET_STATE,
  VERIFY_COMPANY_NAME,
  VALIDATE_CODE,
  SET_US_MAIL_SECURITY_GROUP,
  TIN_ADDRESS_API,
  SET_INFO_ERROR,
  GENERATE_SECURITY_KEY,
} from './constants';

const initialState = {
  reduxMainRadio: '',
  reduxUsMailSecurityRadio: 'Yes',
  reduxValidationErrorType: '',
  verifyCompanyNameSaga: { isLoading: false, isError: false, isSuccess: false },
  claimSaga: { isLoading: false, isError: false, isSuccess: false },
  paymentInfoSaga: { isLoading: false, isError: false, isSuccess: false },
  tinAddressSaga: { isLoading: false, isError: false, isSuccess: false },
  validateSecurityKeySaga: {
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  getSecurityKeySaga: {
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};
export const verifyClaimReducer = createReducer(initialState, {
  [`${GET_CLAIM}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      claimSaga: { isLoading: false, isError: false, isSuccess: true },
    };
  },
  [`${GET_CLAIM}_STARTED`]: (state, action) => {
    return {
      ...state,
      claimSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${GET_CLAIM}_ERROR`]: (state, action) => {
    return {
      ...state,
      claimSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
  [`${SET_MAIN_RADIO_GROUP}`]: (state, action) => {
    return {
      reduxMainRadio: action.payload,
    };
  },
  [`${SET_INFO_ERROR}`]: (state, action) => {
    return {
      reduxValidationErrorType: action.payload,
    };
  },
  [`${SET_US_MAIL_SECURITY_GROUP}`]: (state, action) => {
    return {
      reduxUsMailSecurityRadio: action.payload,
    };
  },
  [`${SET_IS_PROCEDURE_CODE}`]: (state, action) => {
    return {
      reduxIsProcedureCode: action.payload,
    };
  },
  [`${VERIFY_PAYMENT_INFO}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      paymentInfoSaga: { isLoading: false, isError: false, isSuccess: true },
    };
  },
  [`${VERIFY_PAYMENT_INFO}_STARTED`]: (state, action) => {
    return {
      ...state,
      paymentInfoSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${VERIFY_PAYMENT_INFO}_ERROR`]: (state, action) => {
    return {
      ...state,
      paymentInfoSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
  [RESET_STATE]: (state, action) => {
    return { ...initialState };
  },
  [`${VERIFY_COMPANY_NAME}_STARTED`]: (state, action) => {
    return {
      ...state,
      verifyCompanyNameSaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
  [`${VERIFY_COMPANY_NAME}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      ...action.payload,
      verifyCompanyNameSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${VERIFY_COMPANY_NAME}_ERROR`]: (state, action) => {
    return {
      ...state,
      verifyCompanyNameSaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },

  [`${VALIDATE_CODE}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      validateSecurityKeySaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${VALIDATE_CODE}_ERROR`]: (state, action) => {
    return {
      ...action.payload,
      validateSecurityKeySaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },
  [`${VALIDATE_CODE}_STARTED`]: (state, action) => {
    return {
      validateSecurityKeySaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
  [`${TIN_ADDRESS_API}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      tinAddressSaga: { isLoading: false, isError: false, isSuccess: true },
    };
  },
  [`${TIN_ADDRESS_API}_ERROR`]: (state, action) => {
    return {
      ...state,
      tinAddressSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
  [`${TIN_ADDRESS_API}_STARTED`]: (state, action) => {
    return {
      ...state,
      tinAddressSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${GENERATE_SECURITY_KEY}_STARTED`]: (state, action) => {
    return {
      ...state,
      getSecurityKeySaga: {
        isLoading: true,
        isError: false,
        isSuccess: false,
      },
    };
  },
  [`${GENERATE_SECURITY_KEY}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      getSecurityKeySaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${GENERATE_SECURITY_KEY}_ERROR`]: (state, action) => {
    return {
      ...state,
      getSecurityKeySaga: {
        isLoading: false,
        isError: true,
        isSuccess: false,
      },
    };
  },
});
